/* eslint-disable */
import React, { useMemo, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import Table from "components/Table";
import api from "api";
import useRoles from "customHooks/useRoles";
import { useAuth } from "context/auth";
import { getMapValues } from "utils/mapUtils";
import getVillages from "utils/selfUtils/getVillages";
import getHods from "utils/selfUtils/getHods";
import { useMap } from "context/mapContext";
import { useEsriUrls } from "context/esriUrlsContext";
import { handleLoading, useLoading } from "context/LoadingContext";
import { Form } from "react-bootstrap";
import { ErrorHandelFunctionApp } from "utils/ErrorHandelFunction";

function Schemes() {
  const [dataTable, setDataTable] = useState([]);
  const { roles, permissions } = useRoles();
  const [villageDropDownValues, setVillageDropDownValues] = useState([]);
  const [hoodDropDownValues, setHoodDropDownValues] = useState([]);
  const [allHoodDropDownValues, setAllHoodDropDownValues] = useState([]);
  const [auth] = useAuth();
  const [esriUrls] = useEsriUrls();
  const [map, dispatchMap] = useMap();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  const watchedData = watch();

  const { villages, hods } = map;
  const headers = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "#",
        enableColumnFilter: true,
        filterInputInfo: {
          label: "الرقم التسلسلي",
          type: "",
        },
      },
      {
        accessorKey: "userName",
        header: "اسم المستخدم",
        enableColumnFilter: true,
        filterInputInfo: {
          label: "اسم المستخدم",
          // type: "string",
        },
        filterFn: "includesString",
      },
      {
        accessorKey: "userNationalId",
        header: "الرقم الوطني",
        enableColumnFilter: true,
        filterInputInfo: {
          label: "الرقم الوطني",
          // type: "string",
        },
        filterFn: "includesString",
      },
      {
        accessorKey: "dlsKey",
        header: "مفتاح القطعة",
        enableColumnFilter: true,
        filterInputInfo: {
          label: "مفتاح القطعة",
          // type: "string",
        },
        filterFn: "includesString",
      },
      {
        accessorKey: "landUse",
        header: "صفة الإستخدام",
        enableColumnFilter: true,
        filterInputInfo: {
          label: "صفة الإستخدام",
          // type: "string",
        },
        filterFn: "includesString",
      },
      {
        accessorKey: "type",
        header: "نوع المخطط",
        enableColumnFilter: true,
        filterInputInfo: {
          type: "select",
          // [ { id: 'وادي موسى' }, { id: 'الراجف' }, { id: 'الصهوة' } ]
          options: [
            { id: "تجريبي", value: "تجريبي" },
            { id: "فعلي", value: "فعلي" },
            { id: "رسمي", value: "رسمي" },
          ],
          selectOptions: {
            name: "id",
            value: "id",
          },
        },
        filterFn: "includesString",
      },
      {
        accessorKey: "village",
        header: "القرية",
        enableColumnFilter: true,
        filterInputInfo: {
          type: "select",
          options: villageDropDownValues || [],
          selectOptions: {
            name: "id",
            value: "id",
          },
          extraProcess: ({ headers: paramHeaders, newValue }) => {
            const hoodCol = paramHeaders.find((header) => header.id === "hood");
            if (newValue) {
              const vil = villages.find(
                (village) => village.VILL_ANAME === newValue
              );
              const initHoods = hods
                .filter((item) => item.VILL_CODE === vil.VILL_CODE)
                .map((item) => item.HOD_NAME);
              const initHoodDropDown = allHoodDropDownValues.filter((item) =>
                initHoods.includes(item.id)
              );
              setHoodDropDownValues(initHoodDropDown);
            } else {
              setHoodDropDownValues(allHoodDropDownValues);
            }
            hoodCol.column.setFilterValue("");
          },
        },
        filterFn: "includesString",
      },
      {
        accessorKey: "hood",
        header: "الحوض",
        enableColumnFilter: true,
        filterInputInfo: {
          type: "select",
          options: hoodDropDownValues || [],
          selectOptions: {
            name: "id",
            value: "id",
          },
        },
        filterFn: "includesString",
      },
      {
        accessorKey: "creationDate",
        header: "تاريخ الإصدار",

        cell: (param) =>
          new Date(param.cell.row.original?.creationDate).toLocaleString(
            "en-GB",
            {
              year: "numeric",
              month: "numeric",
              day: "numeric",
            }
          ) || "",
      },
      // bookRequesterName, bookNumber
      {
        accessorKey: "bookRequesterName",
        header: "اسم مقدم الطلب",
        enableColumnFilter: true,
        filterInputInfo: {
          label: "اسم مقدم الطلب",
          // type: "string",
        },
        filterFn: "includesString",
      },
      {
        accessorKey: "bookNumber",
        header: "رقم الكتاب",
        enableColumnFilter: true,
        filterInputInfo: {
          label: "رقم الكتاب",
          // type: "string",
        },
        filterFn: "includesString",
      },
    ],
    [villageDropDownValues, hoodDropDownValues, dataTable]
  );
  const [, loadingDispatch] = useLoading();

  const exportHeaders = useMemo(() => {
    if (!roles.systemAdminOrManager && !permissions.employeeCanExportReport)
      return null;
    return {
      id: "الرقم التسلسلي",

      userName: "اسم المستخدم",

      userNationalId: "الرقم الوطني",

      dlsKey: "مفتاح القطعة",

      landUse: "صفة الإستخدام",

      village: "القرية",

      hood: "الحوض",

      creationDateIso: "تاريخ الإصدار",
    };
  }, [permissions.employeeCanExportReport, roles.systemAdminOrManager]);

  const tablePrintable =
    roles.systemAdminOrManager || permissions.employeeCanPrintReport;

  const getLogs = async (data) => {
    handleLoading(loadingDispatch, true);

    try {
      const userLogsRes = await api.post("reports/regulationplan", data);
      let intHods = new Map();
      let intVillages = new Map();
      const initDataTable = userLogsRes.data.data.list.map((item) => {
        intHods.set(item.hood, item.hood);
        intVillages.set(item.village, item.village);
        return {
          ...item,
          creationDateIso:
            new Date(item.creationDate).toLocaleString("en-GB", {
              year: "numeric",
              month: "numeric",
              day: "numeric",
            }) || "",
        };
      });
      intHods = getMapValues(intHods);
      intVillages = getMapValues(intVillages);
      setDataTable(initDataTable);
      setHoodDropDownValues(intHods);
      setAllHoodDropDownValues(intHods);
      setVillageDropDownValues(intVillages);
    } catch (error) {
      console.error("error", error);
    }
    handleLoading(loadingDispatch, false);
  };

  const getParcelInfos = async () => {
    let parcelInfosInit = [];
    if (!villages && esriUrls.DLSParcelsLayer !== undefined) {
      handleLoading(loadingDispatch, true);

      try {
        parcelInfosInit = await Promise.all([
          getVillages({
            layerId: esriUrls.DLSParcelsLayer,
            dispatch: dispatchMap,
            villages,
            token: auth.esriToken,
          }),
          getHods({
            layerId: esriUrls.DLSParcelsLayer,
            dispatch: dispatchMap,
            hods,
            token: auth.esriToken,
          }),
        ]);
      } catch (error) {
        ErrorHandelFunctionApp(error)
      }
      handleLoading(loadingDispatch, false);
    }
    return parcelInfosInit;
  };
  const [printDateHeaderArr, setPrintDateHeaderArr] = useState(undefined);
  const onSubmit = (data) => {
    const { dateFrom, dateTo } = data;
    setPrintDateHeaderArr([dateFrom, dateTo]);
    getLogs(data);
  };

  useEffect(() => {
    (async () => {
      const parcelInfos = await getParcelInfos();
      getLogs(...parcelInfos);
    })();
  }, [esriUrls.DLSParcelsLayer]);
  return (
    <div>
      <form className="table__filter mb-3" onSubmit={handleSubmit(onSubmit)}>
        <div className="table__filter__period">
          <Form.Group className="input input-md date-input">
            <Form.Label>تاريخ من</Form.Label>
            <Form.Control
              type="date"
              {...register(`dateFrom`, {
                required: {
                  value: watchedData.dateTo,
                  message: "الرجاء ادخال الحقل",
                },
              })}
            />
          </Form.Group>
          <Form.Group className="input input-md date-input">
            <Form.Label>تاريخ إلى</Form.Label>
            <Form.Control
              type="date"
              {...register(`dateTo`, {
                required: {
                  value: watchedData.dateFrom,
                  message: "الرجاء ادخال الحقل",
                },
                validate: (dateTo) => {
                  if (!watchedData.dateFrom) return true;
                  return (
                    new Date(dateTo).getTime() >=
                      new Date(watchedData.dateFrom).getTime() ||
                    "الرجاء ادخال تاريخ صحيح"
                  );
                },
                deps: ["dateFrom"],
              })}
            />
            {errors.dateTo && (
              <Form.Text className="text-danger">
                {errors.dateTo.message}
              </Form.Text>
            )}
          </Form.Group>
        </div>
        <div
          className="table__filter__actions"
          style={{ alignSelf: "flex-end" }}
        >
          <button type="submit" className="btn btn--primary fw-bold">
            بحث
          </button>
        </div>
      </form>
      <div
        className="divider my-3"
        style={{ height: 3, backgroundColor: "var(--primary)" }}
      />
      <Table
        data={dataTable}
        columns={headers}
        exportHeaders={exportHeaders}
        printDateHeaderArr={printDateHeaderArr}
        printable={tablePrintable}
        datePeriodHeaderToUseAtHeader="creationDate"
        exportName="عمليات اصدار المخططات"
        headerTitle="عمليات اصدار المخططات"
        printerName={`${auth?.userDetails?.details?.firstName}
          ${auth?.userDetails?.details?.lastName}`}
      />
    </div>
  );
}

export default Schemes;
